import { useEffect, useState } from 'react';

const useScript = (src) => {
  const [status, setStatus] = useState({
    loaded: false,
    error: false,
  });

  useEffect(() => {
    // Avoid loading the script multiple times
    const existingScript = document.querySelector(`script[src="${src}"]`);

    if (existingScript) {
      setStatus({
        loaded: true,
        error: false,
      });
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;

    const handleScript = (e) => {
      setStatus({
        loaded: true,
        error: e.type === 'error',
      });
    };

    script.addEventListener('load', handleScript);
    script.addEventListener('error', handleScript);

    document.body.appendChild(script);

    return () => {
      script.removeEventListener('load', handleScript);
      script.removeEventListener('error', handleScript);
    };
  }, [src]);

  return status;
};

export default useScript;
